










































































import { Component, Vue } from 'vue-property-decorator'
@Component
export default class ResolveAll extends Vue {
  listData = [
    {
      numImg: require('@viewsImg/index/num-1.png'),
      aKey: '实时汇聚全网多渠道好单第一时间发现好单',
      content:
        '获取QQ社群、微信社群和各大选品平台商品推广情况，帮助及时掌握淘客圈内的热度商品，带来订单高峰。',
      imgSquare: require('@viewsImg/index/enlarge-square-1.png'),
      imgCircular: require('@viewsImg/index/enlarge-circular-1.png')
    },
    {
      numImg: require('@viewsImg/index/num-2.png'),
      aKey: '全面展示商品的历史推广情况通过历史数据分析商品',
      content:
        '可按小时、按天，按周期、按销量总量或增量等多维度展示数据，通过查看历史最高销量，历史最低券后价、历史最大优惠力度、最高佣金比例、传播渠道等数据，全面分析影响商品销量增长因素及作出应对策略。',
      imgSquare: require('@viewsImg/index/enlarge-square-2.png'),
      imgCircular: require('@viewsImg/index/enlarge-circular-2.png')
    },
    {
      numImg: require('@viewsImg/index/num-3.png'),
      aKey: '实时提供推广分发渠道数据实时掌握商品的爆款预测',
      content:
        '展示商品各个时间段的采集情况，及分发不同渠道数量，轻松掌握实力团队动向，快人一步预测爆款商品',
      imgSquare: require('@viewsImg/index/enlarge-square-3.png'),
      imgCircular: require('@viewsImg/index/enlarge-circular-3.png')
    },
    {
      numImg: require('@viewsImg/index/num-4.png'),
      aKey: '网罗更多推广案例助力招商及赋能运营谈判',
      content:
        '提供商品全面的历史数据，社群和各大选品平台分发渠道数据，多推广案例做支撑，助力招商及赋能运营谈判并制定合适推广方案，有效提高业绩增长。',
      imgSquare: require('@viewsImg/index/enlarge-square-4.png'),
      imgCircular: require('@viewsImg/index/enlarge-circular-4.png')
    }
  ]
}
